import React, {createContext, useState, useEffect, useContext} from 'react';
const SMALL_SCREEN_SIZE = 1024;
const MOBILE_SCREEN_SIZE = 768;

export const ScreenModeContext = createContext({});

export const ScreenModeProvider = ({ children }) => {
    const [smallScreenMode, setSmallScreenMode] = useState(window.innerWidth <= SMALL_SCREEN_SIZE);
    const [mobileScreenMode, setMobileScreenMode] = useState(window.innerWidth <= MOBILE_SCREEN_SIZE);

    useEffect(() => {
        const handleResize = () => {
            setSmallScreenMode(window.innerWidth <= SMALL_SCREEN_SIZE);
            setMobileScreenMode(window.innerWidth <= MOBILE_SCREEN_SIZE);
        };

        window.addEventListener('gameLoaded', handleResize);
        window.addEventListener('resize', handleResize);
        window.addEventListener('menuSizeChanged', handleResize);
        return () => {
            window.removeEventListener('gameLoaded', handleResize);
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('menuSizeChanged', handleResize);
        }
    }, []);

    const value = {
        smallScreenMode,
        mobileScreenMode,
    };

    return (
        <ScreenModeContext.Provider value={value}>
            {children}
        </ScreenModeContext.Provider>
    );
};

export const useScreenMode = () => {
    const context = useContext(ScreenModeContext);
    if (context === undefined) {
        throw new Error('useScreenMode must be used within a ScreenModeProvider');
    }
    return context;
};
